import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

export default function BrinDateRedirect() {
  const router = useRouter();
  useEffect(() => { router.replace('/jeux/brin'); }, [router]);
  return (
    <Head>
      <meta httpEquiv="refresh" content="0; url=/jeux/brin" />
      <title>Brin | Fenkparet</title>
    </Head>
  );
}

export async function getStaticPaths() {
  const paths = [];
  const cur = new Date('2026-01-01');
  const end = new Date('2026-12-31');
  while (cur <= end) {
    paths.push({ params: { date: cur.toISOString().slice(0, 10) } });
    cur.setDate(cur.getDate() + 1);
  }
  return { paths, fallback: false };
}

export async function getStaticProps() { return { props: {} }; }
